import React, { Component } from 'react'
import styled from "styled-components";
import Axios from 'axios';
import {wrapperEndPoint} from "../../../Utils/Api";

export const FileUploadContainer = styled.div`
    background-color: white;
    padding: 10px;
    margin-top: 10px;
   // width:260px;
    @media (min-width: 678px){
        width:260px;
    }
`;

let KYC_mobileNo;

export default class KYCFileUpload extends Component {
    state = {
        docs : [],
        fileNames:[],
    }
    componentDidMount(){
        document.querySelector("#upload").classList.add("disabled");
    }
    handleFileUpload = (event)=>{
        let files= event.target.files;
        const toBase64 = (file) => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();//new Blob
              reader.readAsArrayBuffer(file);
              reader.onload = () => resolve(this.arrayBufferToBase64(reader.result));
              reader.onerror = error => reject(error);
            });
        };
        
        const tobase64Handler = (files) =>{
            const filePathsPromises =[];
            var fileNames=[]
            let flags=[];
            for(var x = 0; x<files.length; x++) {
                const docSize=(files[x].size / 1024 / 1024).toFixed(2);
                if(docSize > 5) {
                    flags.push(1);
                    alert("Please select a file with size less than 5MB");
                    this.setState({fileNames:[],docs:[]});
                }else{
                    flags.push(0);
                    fileNames.push(files[x].name);
                    filePathsPromises.push(toBase64(files[x]))
                }
            }
            if(flags.includes(0)){
                Promise.all(filePathsPromises).then((data)=>{
                    document.querySelector("#upload").classList.remove("disabled");
                    this.setState({docs:data,fileNames:fileNames});
                });
            }else{
                document.querySelector("#upload").classList.add("disabled");
            }
        }; 
        tobase64Handler(files)
    }
    arrayBufferToBase64 = (buffer)=>{
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
    }
    generateUniqueFileName = (file) =>{
        let msg = this.props.message;
        let currentDate=new Date();
        let curDateandTime= currentDate.getDate() + "-"+ (currentDate.getMonth()+1)  + "-" + currentDate.getFullYear()+ "@" +currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds();
        let {uid,mobile_no}=JSON.parse(msg.substring(msg.indexOf('{'), msg.lastIndexOf('}') + 1));
        let extention=file.substring(file.lastIndexOf('.'), file.length);
        let uniqueFileName=file.split(extention)[0]+"*"+uid+"*"+mobile_no+"*"+curDateandTime+"-BOT"+extention;
        KYC_mobileNo= mobile_no
        return uniqueFileName;
    }
    handleSubmit = (evt)=>{
   
        evt.preventDefault();
        let sendData = []; 
        for(let i=0;i<this.state.docs.length;i++){
            sendData.push({file_name:this.generateUniqueFileName(this.state.fileNames[i]),byteStream:encodeURIComponent(this.state.docs[i]),mobile_number:KYC_mobileNo});
        }
        Axios.post(wrapperEndPoint.docUploadURL,{
            wrapperEndPoint: "/RBLWrapper/rbl/creditCard/uploadDocuments",
            findIFSC: JSON.stringify(sendData),
            },{headers: {"Content-Type": "application/json"}}
        )
        .then((response)=>{
            if(response.data.status === "success"){
                let inputString = "Continue" + "<split>" + response.data.ducument_name;
                window["autosubmit"](inputString);
                
            }else{
                let failString = "Failed!" + "<split>" + "Fail";
                window["autosubmit"](failString);
            }  
          }).catch((error)=>{
              console.log(error);
          }) 
          
        //   console.log(sendData);
    }
    render() {
        return (
            <div>
            <div style={{"width": "234px"}} >Please click on Choose to select multiple files and upload</div>
            <FileUploadContainer>  
             
                <form onSubmit={(evt)=>{this.handleSubmit(evt)}} encType="multipart/form-data">
                    <input type='file' id="fileUpload" hidden onChange={(ev)=>{this.handleFileUpload(ev)}} accept=".png,.jpg,.jpeg,.pdf,.doc,.docx" multiple></input>
                    <div  className="action-elem" onClick={()=>{document.getElementById("fileUpload").click();}}>Choose ➡️</div>
                    {this.state.fileNames.map((data,index)=>{
                        return <div key={index} style={{"padding":"5px"}}>{data}</div>
                    })}
                    <input id="upload" 
                    style={{"width": "234px","outline":"none"}} 
                    type="submit" className="action-elem" value="Upload"></input>
                </form>
            </FileUploadContainer>
            </div>
        )
    }
}
